import React from "react";
import { components } from "react-select";
import { CountryFlags } from "../../../Utils/Constants";
const MenuList = (props) => {
  const { options, setValue } = props;
  return (
    <components.MenuList {...props}>
      {options.map((option, index) => (
        <div
          key={index}
          className="feed-type-menu-item"
          onClick={() => {
            setValue(option);
          }}
        >
          {CountryFlags[option.value] && (
            <img src={CountryFlags[option.value]} alt="type" />
          )}
          {option.label}
        </div>
      ))}
    </components.MenuList>
  );
};

export default MenuList;



// WEBPACK FOOTER //
// ./src/screens/SuperArticles/components/MenuList.js